var Glyphicon = require("components/utility/icons/Glyphicon");

require("org/roster_upload/mapping_control.scss");

class MappingControl extends React.Component {
	constructor(props) {
		super();
		autobind(this);

		var initialMapping = {};
		var initialCertainty = {};


		if (props.initialMatcher) {
			// To pop from
			var useLeft = _.clone(props.left);

			_.each(props.right, (rightItem) => {
				var rightKey = this.getKey(rightItem, false, props);

				var bestLeftItem = undefined;
				var bestCertainty = 0;

				_.each(useLeft, (leftItem) => {
					var certainty = props.initialMatcher(leftItem, rightItem);

					if (certainty > bestCertainty && certainty >= 0.5) {
						bestLeftItem = leftItem;
						bestCertainty = certainty;
					}
				})

				if (bestCertainty > 0) {
					var leftKey = this.getKey(bestLeftItem, true, props);
					initialMapping[leftKey] = rightKey;
					initialCertainty[leftKey] = bestCertainty;

					useLeft = _.without(useLeft, bestLeftItem);

				}

				console.log(bestCertainty, initialMapping, initialCertainty)
			})

			// var matchedRightKeys = new Set();

			// _.each(props.left, function(leftItem) {
			// 	var leftKey = this.getKey(leftItem, true, props);

			// 	_.each(props.right, function(rightItem) {
			// 		var rightKey = this.getKey(rightItem, false, props);

			// 		var certainty = props.initialMatcher(leftItem, rightItem);

			// 		if (certainty > 0 && !matchedRightKeys.has(rightKey)) {
			// 			if ((initialCertainty[leftKey] == undefined) ||
			// 				(initialCertainty[leftKey] < certainty)) {

			// 				initialMapping[leftKey] = rightKey;
			// 				initialCertainty[leftKey] = certainty;
			// 			}
			// 		}
			// 	}.bind(this));

			// 	if (initialMapping[leftKey]) {
			// 		matchedRightKeys.add(this.getKey(initialMapping[leftKey], false, props));
			// 	}
			// }.bind(this));
		}

		this.state = {
			mapping: initialMapping, certainties: initialCertainty,
			leftActiveKey: null, rightActiveKey: null
		};
	}

	getMapping() {
		return this.state.mapping;
	}

	addMapping(leftKey, rightKey) {
		var newMapping = _.clone(this.state.mapping);
		var newCertainties = _.clone(this.state.certainties);

		// Delete other leftKeys mapping to rightKey
		_.each(newMapping, function(right, left) {
			if (right == rightKey) {
				delete newMapping[left];
				delete newCertainties[left];
			}
		});

		// Add current mapping to rightKey
		newMapping[leftKey] = rightKey;
		newCertainties[leftKey] = 1;

		this.setState({
			mapping: newMapping, certainties: newCertainties,
			leftActiveKey: null, rightActiveKey: null
		});
	}

	removeMapping(leftKey) {
		var newMapping = _.clone(this.state.mapping);
		delete newMapping[leftKey];

		var newCertainties = _.clone(this.state.certainties);
		delete newCertainties[leftKey];

		this.setState({ mapping: newMapping, certainties: newCertainties });
	}

	selectItem(itemKey, isLeft) {
		if (isLeft) {
			var activeAttr = "leftActiveKey";
			var otherAttr = "rightActiveKey";
		} else {
			var activeAttr = "rightActiveKey";
			var otherAttr = "leftActiveKey";
		}

		if (this.state[activeAttr] == itemKey) {
			// Clicking again on the same item deselects is
			var update = {};
			update[activeAttr] = null;
			this.setState(update);

		} else if ((this.state[activeAttr] != null) || (this.state[otherAttr] == null)) {
			// Clicking on a different item in the same column switches the selected item
			// ALSO: clicking on an item selects it if the nothing is selected in the other column
			var update = {};
			update[activeAttr] = itemKey;
			this.setState(update);

		} else if (isLeft) {
			this.addMapping(itemKey, this.state.rightActiveKey)
		} else {
			this.addMapping(this.state.leftActiveKey, itemKey)
		}
	}

	defaultItemRenderer(item) {
		var elements = _.map(_.keys(item), function(key) {
			return (
				<div key={ key }>
					<strong>{ key }</strong>: { item[key] }
				</div>
			);
		});
		return (
			<div>
				{ elements }
			</div>
		);
	}

	getKey(item, isLeft, props) {
		props = props || this.props; // Allow us to use this in constructor
		if (isLeft) {
			return item[props.keyAttr];
		} else {
			return item[props.rightKeyAttr || props.keyAttr];
		}
	}

	renderItem(item, isLeft) {
		var renderer = this.props.itemRenderer || this.defaultItemRenderer;
		var key = this.getKey(item, isLeft);

		if (isLeft) {
			var className = "leftItem";
			if (this.state.leftActiveKey == key) {
				className += " active";
			}
		} else {
			var className = "rightItem";
			if (this.state.rightActiveKey == key) {
				className += " active";
			}
		}

		return (
			<td onClick={ this.selectItem.bind(this, key, isLeft) } className={ className }>
				{ renderer(item, isLeft) }
			</td>
		);
	}

	renderMappedRows(mappedPairs) {
		return _.map(mappedPairs, function(leftRightPair, index) {
			var leftItem = this.renderItem(leftRightPair[0], true);
			var rightItem = this.renderItem(leftRightPair[1], false);

			var leftKey = this.getKey(leftRightPair[0], true);

			if (this.state.certainties[leftKey] >= 1) {
				var linkIcon = "link";
			} else {
				var linkIcon = "option-horizontal";
			}

			return (
				<tr key={ "mapped-" + index }>
					{ leftItem }
					<td className="joinItem">
						<button onClick={ this.removeMapping.bind(this, leftKey) }
							className="btn buttonDefault">
							<Glyphicon icon={ linkIcon } className="showNormal" />
							<Glyphicon icon="remove" className="showHover" />
						</button>
					</td>
					{ rightItem }
				</tr>
			);
		}.bind(this));
	}

	renderUnmappedRows(unmappedLeft, unmappedRight) {
		var rowCount = Math.max(unmappedLeft.length, unmappedRight.length);
		var unmappedRows = [];

		var leftItem, rightItem, i;
		for (i = 0; i < rowCount; i++) {
			leftItem = rightItem = undefined;
			if (unmappedLeft[i]) {
				leftItem = this.renderItem(unmappedLeft[i], true);
			} else {
				leftItem = (<td />);
			}
			if (unmappedRight[i]) {
				rightItem = this.renderItem(unmappedRight[i], false);
			} else {
				rightItem = (<td />);
			}

			unmappedRows.push(
				<tr key={ "unmapped-" + i }>
					{ leftItem }
					<td className="joinItem"></td>
					{ rightItem }
				</tr>
			);
		}

		return unmappedRows;

	}

	render() {
		var sorter = this.props.itemSorter || _.identity;

		var sortedLeft = sorter(this.props.left, true);
		var sortedRight = sorter(this.props.right, false);

		var unmappedLeft = []; // We'll add to this
		var unmappedRight = _.clone(sortedRight); // We'll remove from this

		var mappedPairs = [];

		for (var i = 0; i < sortedLeft.length; i++) {
			var leftItem = sortedLeft[i];
			var leftKey = this.getKey(leftItem, true);

			if (_.has(this.state.mapping, leftKey)) {

				var rightKey = this.state.mapping[leftKey];
				var rightItem = _.find(sortedRight, function(item) {
					return this.getKey(item, false) == rightKey;
				}.bind(this));

				if (rightItem == null) {
					console.error("Missing right item with key: " + rightKey);
				}

				mappedPairs.push([leftItem, rightItem]);
				unmappedRight = _.without(unmappedRight, rightItem);
			} else {
				unmappedLeft.push(leftItem)
			}
		}

		var mappedRows = this.renderMappedRows(mappedPairs);
		var unmappedRows = this.renderUnmappedRows(unmappedLeft, unmappedRight);

		if (this.props.leftLabel || this.props.rightLabel) {
			var headerRow = (
				<tr>
					<th>{ this.props.leftLabel }</th>
					<th></th>
					<th>{ this.props.rightLabel }</th>
				</tr>
			);
		}

		return (
			<div className="mappingControl">
				<table>
					<tbody>
						{ headerRow }
						{ mappedRows }
						{ unmappedRows }
					</tbody>
				</table>
			</div>
		);
	}
};

MappingControl.propTypes = StrictPropTypes({
	left: PropTypes.array.isRequired,
	right: PropTypes.array.isRequired,

	// Key of the items on the left, and right if no rightKeyAttr is provided
	// Used to store the mapping. Values should be unique with each of 'left' and 'right'
	keyAttr: PropTypes.string.isRequired,
	rightKeyAttr: PropTypes.string,

	// Optional function to render items:
	//    takes item, (object in left/right), as 1st parameter
	//    takes isLeft, boolean, as optional 2nd parameter
	itemRenderer: PropTypes.func,

	// Optional function to render items.
	//   Takes a list of items to sort as the first parameter
	//   Takes isLeft, boolean, as optional 2nd parameter
	itemSorter: PropTypes.func,


	// Optional function to generate the initialMapping
	// 	 Takes a right item as the first parameter
	//   Takes a left item as the second parameter
	initialMatcher: PropTypes.func,

	// Labels to put at the top of the columns
	leftLabel: PropTypes.string,
	rightLabel: PropTypes.string
});

module.exports = MappingControl;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/MappingControl.js